import type { LoaderFunctionArgs } from "react-router-dom";
import { validateSlug } from "@/utils/api/slugValidation";

/**
 * Loader function to validate if a business slug exists.
 * Throws a 404 Response if the slug is invalid.
 */
export async function validateSlugLoader({ params }: LoaderFunctionArgs) {
  if (!params.businessSlug) {
    throw new Response("Not Found", { status: 404 });
  }
  const exists = await validateSlug(params.businessSlug);
  if (!exists) throw new Response("Not Found", { status: 404 });
  return null;
}
